export const avannisReportsTheme = {
  /* These are the series colors that will be used in sequential order */
  colors: ['#0493FC', '#E24585', '#132749', '#B30838', '#FFAA00', '#3BB273',
    '#007F80', '#CC66FF', '#6AF9C4'],
  chart: {
    backgroundColor: '#FFF',
  },
  title: {
    style: {
      color: '#000',
      font: 'bold 16px "Trebuchet MS", Verdana, sans-serif',
    }
  },
  subtitle: {
    style: {
      color: '#666666',
      font: 'bold 12px "Trebuchet MS", Verdana, sans-serif'
    }
  },

  legend: {
    itemStyle: {
      font: '9pt Trebuchet MS, Verdana, sans-serif',
      color: 'black'
    },
    itemHoverStyle: {
      color: 'gray'
    }
  },

  credits: {
    enabled: false,
  }
}
